import React from "react";

import {
  Environment,
  NativeBridgeAvailable,
  PermissionStatus,
} from "@unu/ui-enums";

import {
  registerPlugins,
  setContext,
  setPermissionStatus,
} from "@unu/ui-insights";

import { NativeBridgeInsightsInterface } from "@unu/web-insights-bridge";

import { ConsoleInsightsInterface } from "@unu/ui-insights-console";

import { FirebaseInsightsInterface } from "@unu/web-insights-firebase";

const FirebaseConfig = {
  apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_APP_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
};

export const InsightsProvider = () => {
  React.useEffect(() => {
    setContext({
      environment:
        import.meta.env.VITE_APP_INSIGHTS_ENVIRONMENT ?? Environment.Production,
      version: import.meta.env.VITE_APP_VERSION,
    });

    let plugins: any = {
      nativeBridge: NativeBridgeInsightsInterface,
    };

    if (!NativeBridgeAvailable) {
      plugins = {
        console: ConsoleInsightsInterface,
        firebase: {
          ...FirebaseInsightsInterface,
          initializationParams: {
            config: FirebaseConfig,
          },
        },
      };
    }

    registerPlugins(plugins);

    if (!NativeBridgeAvailable) {
      setPermissionStatus({
        firebase: PermissionStatus.Approved,
      });
    }
  }, []);

  return <React.Fragment />;
};
